export enum GoalOfCareStatus {
  ACTIVE = "ACTIVE",
  RESOLVED = "RESOLVED",
}



// WEBPACK FOOTER //
// ./src/models/patient-chart/goal-of-care.ts